import { render, staticRenderFns } from "./SubCom5.vue?vue&type=template&id=fe6729ea&scoped=true"
import script from "./SubCom5.vue?vue&type=script&lang=js"
export * from "./SubCom5.vue?vue&type=script&lang=js"
import style0 from "./SubCom5.vue?vue&type=style&index=0&id=fe6729ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6729ea",
  null
  
)

export default component.exports